import React, { Component } from 'react';

class TrRow extends Component {

	render() {
		return (
			<tr>
				<td>{this.props.date}</td>
				<td title={this.props.userId} style={this.props.followed?{color:'blue'}:{color:'black'}}>{this.props.user}</td>
				<td>{this.props.text}</td>
				<td style={(this.props.day.startsWith("-"))?{color:'red'}:{color:'green'}}>{this.props.day}</td>
				<td style={(this.props.nextDay.startsWith("-"))?{color:'red'}:{color:'green'}}>{this.props.nextDay}</td>
				<td style={(this.props.nextWeek.startsWith("-"))?{color:'red'}:{color:'green'}}>{this.props.nextWeek}</td>
			</tr>
		);
	}
}

export default TrRow;


// WEBPACK FOOTER //
// ./src/components/TrRow.js